import { Component, OnInit, ElementRef, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
// import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
// import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
//import { acceptError } from 'src/app/models/accept-suggetions.service';
//import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { MatSnackBar } from '@angular/material/snack-bar';
//import { start } from 'repl';
// import { MatDialog } from '@angular/material/dialog';
// import { NoopScrollStrategy } from '@angular/cdk/overlay'
// import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
// import { EnglishGrammarCheckerComponent } from 'src/app/Components/english-grammar-checker/english-grammar-checker.component';
// import { environment } from 'src/environments/environment';

//declare function ire(string,{}): any;
@Component({
  selector: 'app-spell-checker',
  templateUrl: './spell-checker.component.html',
  styleUrls: ['./spell-checker.component.scss']
})
export class SpellCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
    // private logger: NGXLogger,
  ) {
   // window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
    this.document.body.classList.add('nosnipptFooter');
  }

  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("Free Spell Checker | AI-powered Online Spell and Grammar Check");
    this.metaTagService.updateTag({ name: 'description', content: "Enhance your writing with our free AI-powered spell checker. Instantly detect and correct spelling and grammar mistakes online for clear, error-free content." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Free Spell Checker | AI-powered Online Spell and Grammar Check" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Enhance your writing with our free AI-powered spell checker. Instantly detect and correct spelling and grammar mistakes online for clear, error-free content." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/spell-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/LearnGrammarwithTrinka.png' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Free Spell Checker | AI-powered Online Spell and Grammar Check' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Enhance your writing with our free AI-powered spell checker. Instantly detect and correct spelling and grammar mistakes online for clear, error-free content." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/LearnGrammarwithTrinka.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-ortografico' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/spell-checker' });
    if (isPlatformBrowser(this.platformId)) {

      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        console.log("cgrome")
        $("#GCChromeButton").css("display", "block");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "block");
        $("#GCEdgeButton").css("display", "none");
        return 'Firefox';

      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'IE';
      }
      else {
        return 'unknown';
      }
    }
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org","@graph":[{"@type":"Product","name":"Spell Checker","image":"https://www.trinka.ai/assets/images/WritingMoreEffective.png","description":"Enhance your writing with our free AI-powered spell checker. Instantly detect and correct spelling and grammar mistakes online for clear, error-free content.","brand":{"@type":"Brand","name":"Trinka AI"},"offers":{"@type":"Offer","url":"https://www.trinka.ai/pricing","priceCurrency":"USD","price":"0","priceValidUntil":"2030-12-31","availability":"InStock","hasMerchantReturnPolicy":{"@type":"MerchantReturnPolicy","url":"https://www.trinka.ai/termsofservices","returnPolicyCategory":"https://schema.org/MerchantReturnNotPermitted","applicableCountry":"GL"},"shippingDetails":{"@type":"OfferShippingDetails","shippingDestination":{"@type":"DefinedRegion","addressCountry":"ALL"},"shippingRate":{"@type":"MonetaryAmount","value":"0","currency":"USD"},"deliveryTime":{"@type":"ShippingDeliveryTime","handlingTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"},"transitTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"}}}},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"review":{"@type":"Review","author":{"@type":"Person","name":"Dr. Abdalla Machano"},"reviewRating":{"@type":"Rating","ratingValue":"5","bestRating":"5"},"reviewBody":"Trinka AI has significantly improved my academic writing. It has helped me become more confident in my writing by quickly and accurately identifying grammatical and spelling errors."}},{"@type":"FAQPage","mainEntity":[{"@type":"Question","name":"What is a spell checker?","acceptedAnswer":{"@type":"Answer","text":"A spell checker is a tool that helps identify misspelled words or typographical errors in your documents and replace them with their correct versions based on the context."}},{"@type":"Question","name":"How does Trinka check for spelling errors?","acceptedAnswer":{"@type":"Answer","text":"Just paste your content in the editor and click on Check my writing. Trinka will highlight all the spelling errors and provide the best contextual spelling suggestions."}}]},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai"},{"@type":"ListItem","position":2,"name":"Spell Checker","item":"https://www.trinka.ai/spell-checker"}]},{"@type":"SoftwareApplication","name":"Spell Checker","operatingSystem":"Web-based","applicationCategory":"Writing Tools","aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"offers":{"@type":"Offer","price":"0","priceCurrency":"USD","availability":"Online","url":"https://www.trinka.ai/spell-checker"}}]}
    `;

    this._renderer2.appendChild(this._document.head, script);

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  ngOnDestroy() {
    this.document.body.classList.remove('nosnipptFooter');
  }

  ngAfterViewInit() {
    const observer = new MutationObserver(() => {
      const editors = document.querySelectorAll('.editor');
  
      editors.forEach((editor) => {
        editor.setAttribute('data-gramm', 'false');
        editor.setAttribute('data-gramm_editor', 'false');
        editor.setAttribute('data-enable-grammarly', 'false');
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
}
